import { MinimumSegment } from '../../../domain/segments';

export type SegmentWithAudio = { segment: MinimumSegment; audio: Buffer };

export type SegmentWithSource = { segment: MinimumSegment; audioSrc: string };

export enum PlaybackTech {
  MEDIA_SOURCE = 'MEDIA_SOURCE',
  AUDIO_SRC = 'AUDIO_SRC',
}
